import React from 'react';

import { Navbar, Header, Searchbar, About, Features, Footer } from '../components';


const Home = () => {
  return (
    <>
      <Navbar />
      <Header />
      <Searchbar />
      <About />
      <Features />
      <Footer />
    </>
  );
}


export default Home;
